module.exports = "https://static.wagwalking.com/_next/static/images/pet-5-4b554c060f143289275f868447de9c45.png";